import React from 'react';

const ChooseUs = () => {
    return (
        <div className='mt-5'>
          <h2 className='mt-4 mb-2 text-3xl text-purple-800' >All are mentors are highly skilled</h2>
        <div className="hero min-h-screen bg-base-200">
          
  <div className="hero-content flex-col lg:flex-row-reverse">
    <img src="https://images.pexels.com/photos/5212339/pexels-photo-5212339.jpeg?auto=compress&cs=tinysrgb&w=600" />
    <div>
      <h1 className="text-5xl font-bold">Countries largest E-Learning Platfrom</h1>
      <p className="py-6">We offer differrent types of valuable courses. Like java, phython, c#, c++ etc. out mentors are highly skill full.</p>
      <button className="btn btn-primary">Enroll Now</button>
    </div>
  </div>
</div>
        </div>
    );
};

export default ChooseUs;